export const URL = "https://shangilia-server.onrender.com";
// export const URL = "http://localhost:5000";
